/**
 * Normalizes price from API (may be string from Prisma Decimal) to number.
 */
export function toNumber(price: number | string | null | undefined): number {
  if (price == null) return 0;
  if (typeof price === 'number' && !Number.isNaN(price)) return price;
  const n = Number(price);
  return Number.isNaN(n) ? 0 : n;
}

const LOCALE_CO = 'es-CO';

/** Two decimal places, thousands separator (v1 Colombia). Example: 200.000,00 */
function formatDecimalEsCo(value: number): string {
  return new Intl.NumberFormat(LOCALE_CO, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(value);
}

/**
 * Formats a numeric amount without currency code (for labels that print the code separately).
 */
export function formatAmountEsCo(price: number | string | null | undefined): string {
  return formatDecimalEsCo(toNumber(price));
}

/**
 * Formats price for display. Handles string or number from API.
 * Uses locale es-CO: thousands with dot, decimals with comma (e.g. COP 200.000,00).
 */
export function formatPrice(
  price: number | string | null | undefined,
  currency?: string,
): string {
  const n = toNumber(price);
  const formatted = formatDecimalEsCo(n);
  const cur = currency?.trim() || '';
  return cur ? `${cur} ${formatted}` : formatted;
}
